/**
 * Uniform display schema for sender addresses in the "Absender" dropdowns:
 * `[Absendername] <[E-Mail Adresse]>`. Without a sender name only the bare
 * address is shown.
 */
export const formatSenderLabel = (address: string, senderName?: string): string => {
  const trimmedName = senderName?.trim()

  return trimmedName ? `${trimmedName} <${address}>` : address
}
